'use strict';

module.exports = {
    PROMOTION_CALLBACK: 'promotion_callback',
    PROMOTION_EXECUTION: 'promotion_execution',
};
